import useScript from "../helpers/useScript.ts";

interface Props {
	src: string,
}

function RenderScript({	src = ''}: Props) {
	useScript(src);

	return null;
}

export default RenderScript;
